export default "__VITE_ASSET__CkVlmUBM__"